'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to show a button expanding and collapsing content details
 */
    .directive('capExpandCollapseButton', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            transclude: true,
            scope: {
                owner: "=?",
                subowner: "=?"
            },
            link: function link(scope, element, attrs, ngModel) {
                scope.toggle = function() {
                    ngModel.$setViewValue(!ngModel.$viewValue);
                };

                scope.isExpanded = function() {
                    return ngModel.$viewValue;
                };

                scope.capId = 'toggle' + (scope.owner && '_' + scope.owner) + (scope.subowner && '_' + scope.subowner);

                scope.hintExpand = attrs.hintExpand || 'collapse_tooltip_closed';
                scope.hintCollapse = attrs.hintCollapse || 'collapse_tooltip_opened';
            },
            templateUrl: "templates/expandcollapsebutton.html"
        }
    });